import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const TableWrapper = styled.div`
  font-family: ${theme.fonts.Regular};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  display: grid;
  max-width: 100%;

  & > div {
    flex-grow: 1;
    .mantine-Text-root {
      color: #000 !important;
    }
    background-color: #EEEEEE;
    table {
      border-spacing: 0;
      border-bottom: 1px solid #d4d4d4;
      border-right: 1px solid rgb(200, 200, 200);
      border-left: 1px solid rgb(200, 200, 200);
      border-radius: 0px 0px 8px 8px;

      thead {
        z-index: 3;
        @media (max-width: 935px) {
          top: -7px;
        }
        background-color: ${theme.colours.lightGray};
        tr {
          th {
            background-color: #eeeeee;
            padding: 4px 10px;
            border-bottom: 0.5px solid ${theme.colours.newOutline} !important;
            border-right-color: ${theme.colours.newOutline} !important;
            border-left-color: ${theme.colours.newOutline} !important;
            color: ${theme.colours.blackText};
            font-size: 14px;
            font-weight: 400;
            font-family: ${theme.fonts.Regular};
            border-width: 0.5px;
            border-bottom: 1px solid rgb(200, 200, 200);
            div {
              font-size: 14px;
              line-height: 22px;
              font-weight: 400;
              font-family: ${theme.fonts.Regular};
              color: #303030;
            }
            &:first-child {
              /* border-right: 1px solid rgb(200, 200, 200); */
              @media (min-width: 768px) {
                padding-inline-start: 20px;
              }
            }
            &:last-child {
              border-left: 1px solid rgb(200, 200, 200);
              @media (min-width: 768px) {
                padding-inline-start: 20px;
              }
            }
            &:nth-child(2) {
              padding-inline-start: 5px;
            }
            text-align: center;
          }
        }
      }
      tbody {
        tr {
          height: 50px;
          padding: 24px 15px;

          td {
            white-space: nowrap;
            padding: 0 10px;
            font-size: 14px !important;
            line-height: 20px;
            font-weight: 400;
            font-family: ${theme.fonts.Regular};
            color: #303030;
            @media (max-width: 935px) {
              padding: 0 8px;
            }
            font-size: 14px;
            color: ${theme.colours.gray2};
            font-family: ${theme.fonts.Regular};
            color: ${theme.colours.black_2};
            text-align: center;
            .circle {
              width: 8px;
              height: 8px;
              border-radius: 6px;
              background-color: #ebebeb;
            }
            &:first-child {
              max-width: 170px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              @media (max-width: 935px) {
                max-width: 100px;
              }
              &:lang(ar) {
                /* border-right: 1px solid ${theme.colours.newOutline}; */
                /* border-radius: 0 8px 8px 0; */
              }
              &:lang(en) {
                /* border-left: 1px solid ${theme.colours.newOutline}; */
                /* border-radius: 8px 0 0 8px; */
              }
              padding-inline-end: 11px;
              @media (min-width: 768px) {
                padding-inline-end: 20px;
              }
            }
            &:nth-child(2) {
              text-align: center;
              @media (min-width: 768px) {
                /* width: 160px; */
              }
            }
            &:last-child {
              padding-inline-start: 11px;
              cursor: pointer;
              &:lang(ar) {
                /* border-left: 1px solid ${theme.colours.newOutline}; */
                /* border-radius: 8px 0 0 8px; */
              }
              &:lang(en) {
                /* border-right: 1px solid ${theme.colours.newOutline}; */
                /* border-radius: 0 8px 8px 0; */
              }
              @media (min-width: 768px) {
                padding-inline-start: 20px;
              }
            }
            .edit_container {
              button {
                background-color: transparent;
                color: ${theme.colours.gray2};
                font-family: 'regular';
                @media (max-width: 935px) {
                  padding: 2px;
                }
                a {
                  color: ${theme.colours.blackText};
                  text-decoration: none;
                }
                > div {
                  color: ${theme.colours.blackText};
                  border-radius: 50%;
                  width: 22px;
                  height: 22px;
                  font-family: regular;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  line-height: 0px;
                }
                &:lang(en) {
                  transform: rotate(180deg);
                }
              }
            }
            span.status {
              font-family: ${theme.fonts.Regular};
              background-color: #f4f4f4;
              padding: 1px 8px;
              border-radius: 6px;
              font-size: 14px;
              color: ${theme.colours.Danger};

              &.status-new {
                background-color: #f4f4f4;
                color: #ee9d08;
              }
              &.status-open {
                background-color: #f4f4f4;
                color: #2a2acc;
              }
              &.status-approved {
                background-color: #c8e5d0;
                color: ${theme.colours.blackText};
              }
            }

            span.time {
              font-family: ${theme.fonts.Regular};
              background-color: #f4f4f4;
              padding: 1px 8px;
              border-radius: 6px;
              font-size: 14px;
              color: black;
            }
          }
          &:last-child {
            td {
              &:first-child {
                border-bottom-right-radius: 8px;
              }
              &:last-child {
                border-bottom-left-radius: 8px;
              }
            }
          }
        }
      }
    }
  }
  .action_container {
    justify-content: flex-start;
  }
`;

export const TableHead = styled.p`
  font-family: ${theme.fonts.Regular};
  color: ${theme.colours.gray2};
  font-size: 14px;
  font-weight: 400;
`;

export const ThreeDotButton = styled.button`
  border: 0;
  svg {
    cursor: pointer;
    font-size: 17px;
    color: ${theme.colours.gray};
  }
`;

export const CardsContainer = styled.div`
  background-color: #eeeeee;
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const WorkflowCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 16px 20px;
  margin: 12px 0;
  position: relative;
  border: 0.5px solid ${theme.colours.newOutline};
  display: flex;
  flex-direction: column;
  min-height: 75px;
  width: 100%;
  min-width: 0;
  overflow: hidden;

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 16px;
  }

  @media (max-width: 935px) {
    padding: 12px 16px;
    min-height: 75px;
    margin: 8px 0;

    &:first-child {
      margin-top: 12px;
    }

    &:last-child {
      margin-bottom: 12px;
    }
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  flex: 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow: visible;
  padding: 0;

  @media (max-width: 935px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    position: static;
  }
`;

export const CardMainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  inset-inline-start: 0;
  justify-content: center;
  align-items: flex-start;
  max-width: 33%;

  @media (max-width: 935px) {
    position: static;
    gap: 6px;
    width: 100%;
    max-width: 100%;
    align-items: flex-start;
  }
`;

export const CardInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  max-width: 33%;
  margin-inline-start: 33%;
  margin-inline-end: 33%;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 935px) {
    gap: 2px;
    width: 100%;
    max-width: 100%;
    margin-inline-start: 0;
    margin-inline-end: 0;
    align-items: flex-start;
  }
`;

export const CardActionColumn = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  inset-inline-end: 0;
  justify-content: center;
  align-items: flex-end;
  max-width: 33%;

  @media (max-width: 935px) {
    position: static;
    width: 100%;
    max-width: 100%;
    align-items: flex-end;
  }
`;

export const CardTitle = styled.h3`
  font-family: ${theme.fonts.SemiBold};
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  margin: 0;
  line-height: 20px;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  @media (max-width: 935px) {
    font-size: 15px;
  }
`;

export const CardInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  font-size: 12px !important;

  .card-details-text {
    font-family: ${theme.fonts.Regular};
    font-size: 12px !important;
    color: ${theme.colours.blackText};
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 935px) {
    justify-content: flex-start;

    .card-details-text {
      font-size: 12px !important;
      text-align: left;
    }
  }
`;

export const CardInfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  font-size: 12px !important;

  .card-details-text {
    font-family: ${theme.fonts.Regular};
    font-size: 12px !important;
    color: ${theme.colours.blackText};
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 935px) {
    justify-content: flex-start;

    .card-details-text {
      font-size: 12px !important;
      text-align: left;
    }
  }
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 935px) {
    display: flex !important;
    width: 100%;
    justify-content: flex-end;
    min-width: unset;
    gap: 8px;
    flex-shrink: 0;
  }

  .dots-menu-btn {
    background-color: transparent;
    border: 1px solid #d4d4d4;
    border-radius: 8px;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-family: ${theme.fonts.Regular};
    font-size: 12px;
    line-height: 1;
    color: ${theme.colours.blackText};
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    box-sizing: border-box;

    &:hover {
      background-color: #f9f9f9;
      border-color: #303030;
    }

    &:active {
      transform: scale(0.98);
    }

    svg {
      width: 12px;
      height: 12px;
      flex-shrink: 0;
    }

    @media (max-width: 935px) {
      padding: 5px 10px;
      font-size: 12px;
      height: 28px;
    }
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  min-height: 300px;

  p {
    margin: 8px 0;

    &.empty-title {
      font-size: 18px;
      color: ${theme.colours.blackText};
      font-family: ${theme.fonts.Medium};
    }

    &.empty-description {
      font-size: 14px;
      color: ${theme.colours.gray2};
      font-family: ${theme.fonts.Regular};
      max-width: 500px;
    }
  }
`;
